export const CalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={props.stroke || "#161C22"}
    {...props}
  >
    <path
      d="M13 13.25H3C2.30964 13.25 1.75 12.6904 1.75 12V4C1.75 3.30964 2.30964 2.75 3 2.75H13C13.6904 2.75 14.25 3.30964 14.25 4V12C14.25 12.6904 13.6904 13.25 13 13.25Z"
      stroke="inherit"
      strokeWidth="1.5"
    />
    <rect x="4" y="5" width="1.5" height="1.5" fill="inherit" />
    <rect x="4" y="1" width="1.5" height="2.5" fill="inherit" />
    <rect x="10.5" y="1" width="1.5" height="2.5" fill="inherit" />
  </svg>
);
